import React from "react";
import { Link } from "react-router-dom";
import { RoutePaths } from "../../../../Constants/RoutePaths";
import ArticleCategoryDTO from "../../../../Models/DTOs/ArticleCategoryDTO";

export default function ArticleTopics({ categories, selectedId }: {
    categories: ArticleCategoryDTO[];
    selectedId?: number;
}) {
    return <nav className="article-feed__topics" aria-label="Article topics">
        <Link to={RoutePaths.BrowseArticles} className={selectedId === undefined ? "is-active" : undefined}
            aria-current={selectedId === undefined ? "page" : undefined}>All articles</Link>
        {categories.map(category => <Link key={category.id} to={RoutePaths.ArticleCategory(category.id)}
            className={selectedId === category.id ? "is-active" : undefined}
            aria-current={selectedId === category.id ? "page" : undefined}>{category.title}</Link>)}
    </nav>;
}